module.exports = __webpack_public_path__ + "media/images/products-banner-896f6d39ff344b7fa9a7c14eaf5a4f29.jpg";